import { z } from 'zod'

// The entity types that can be used for custom fields in request forms
export const RequestFormCustomFieldEntityTypeSchema = z.enum([
  'supplier',
  'purchase-order',
  'supplier-profile',
  'bank-account',
  'user-attribute',
  'agreement-term',
  'category',
  'market',
])
export type RequestFormCustomFieldEntityType = z.infer<typeof RequestFormCustomFieldEntityTypeSchema>

export const RequestFormCustomFieldPropertySchema = z.object({
  id: z.string(),
  type: RequestFormCustomFieldEntityTypeSchema,
})
export type RequestFormCustomFieldProperty = z.infer<typeof RequestFormCustomFieldPropertySchema>
